import { useTranslation } from "react-i18next";
import { Area } from "../../types/area";
import { useState } from "react";
import { EditAreaModal } from "./EditAreaModal";

interface AreaTableRowProps {
  area: Area;
}

export const AreaTableRow = ({ area }: AreaTableRowProps) => {
  const { t } = useTranslation();
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  return (
    <>
      <tr className="block md:table-row border-b md:border-none">
        <td className="hidden md:table-cell">
          <label>
            <input type="checkbox" className="checkbox" />
          </label>
        </td>
        <td className="block md:table-cell py-3 md:py-4">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-1 md:gap-3">
            <div>
              <div className="font-bold">{area.name}</div>
              <div className="text-sm opacity-70 md:hidden mt-1">
                <div>{t("areas.modal.latitude")}: {area.coordinate.lat}</div>
                <div>{t("areas.modal.longitude")}: {area.coordinate.long}</div>
              </div>
            </div>
          </div>
        </td>
        <td className="hidden md:table-cell">{area.code}</td>
        <td className="hidden md:table-cell">
          <div className="text-sm">
            <div>{t("areas.modal.latitude")}: {area.coordinate.lat}</div>
            <div>{t("areas.modal.longitude")}: {area.coordinate.long}</div>
          </div>
        </td>
        <td className="block md:table-cell py-2 md:py-4">
          <div className="flex gap-2 justify-end md:justify-start">
            <button
              className="btn btn-ghost btn-sm"
              onClick={() => setIsEditModalOpen(true)}
            >
              {t("areas.table.edit")}
            </button>
          </div>
        </td>
      </tr>

      <EditAreaModal
        isOpen={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        area={area}
      />
    </>
  );
};
